export default "__VITE_ASSET__BBUPBugc__"